import React, { useEffect, useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import api from "../../lib/api";
import { PageTitle, Card, Badge, Loading } from "../portal/ui";

export default function ControlDues() {
  const [rows, setRows] = useState(null);
  const [remind, setRemind] = useState({ state: "idle", result: null });
  useEffect(() => { api.get("/admin/dues").then(({ data }) => setRows(data)); }, []);
  const send = async () => {
    if (!window.confirm("Email a reminder to every Brother with dues outstanding?")) return;
    setRemind({ state: "sending" });
    try { const { data } = await api.post("/admin/dues/remind"); setRemind({ state: "done", result: data }); }
    catch { setRemind({ state: "error" }); }
  };
  if (!rows) return <Loading />;
  const unpaid = rows.filter((r) => r.status !== "Paid");
  return (
    <div data-testid="control-dues">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <PageTitle eyebrow="Platform Administration" title="Dues" sub={`${unpaid.length} outstanding of ${rows.length} subscriptions.`} />
        <button onClick={send} disabled={!unpaid.length || remind.state === "sending"} className="btn-sapphire" data-testid="control-dues-remind">
          {remind.state === "sending" ? <Loader2 size={15} className="animate-spin" /> : <BellRing size={15} />} Send reminders
        </button>
      </div>
      {remind.state === "done" && <p className="mb-4 font-sans text-sm text-emerald" data-testid="control-dues-result">Sent {remind.result.sent} of {remind.result.recipients?.length} reminders.</p>}
      {remind.state === "error" && <p className="mb-4 font-sans text-sm text-garnet">Could not send reminders.</p>}
      <Card className="overflow-x-auto !p-0">
        <table className="w-full min-w-[600px] font-sans text-sm">
          <thead>
            <tr className="border-b border-sapphire-deep/10 text-left text-[11px] uppercase tracking-widest text-stonegrey">
              <th className="px-6 py-4">Brother</th><th className="px-4 py-4">Year</th><th className="px-4 py-4">Amount</th><th className="px-4 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.email} className="border-b border-sapphire-deep/5" data-testid={`dues-row-${r.email}`}>
                <td className="px-6 py-3"><p className="text-sapphire-deep">{r.name}</p><p className="text-[11px] text-stonegrey">{r.email} · {r.rank}</p></td>
                <td className="px-4 py-3">{r.year}</td>
                <td className="px-4 py-3">S${r.amount}</td>
                <td className="px-4 py-3"><Badge>{r.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
